import React from "react";
import FormItem from "../FormItem";

export default function DetailItemComponent({ initialValues }) {
  return (
    <FormItem isView handleSubmit={() => {}} initialValues={initialValues} />
  );
}
